// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__s7n0a","head":"ProcedureTableInfo_head__z8QG-"};